module.exports = __webpack_public_path__ + "img/50B.f7a06892.png";